import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ComingSoonWorkflowProps {
  title: string;
  description: string;
  icon: LucideIcon;
  features?: string[];
}

export const ComingSoonWorkflow: React.FC<ComingSoonWorkflowProps> = ({
  title,
  description,
  icon: Icon,
  features = [],
}) => {
  return (
    <div className="flex-1 flex items-center justify-center min-h-0 p-6">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-gradient-to-br from-slate-700/50 to-slate-600/50 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6 border border-slate-600/30">
          <Icon className="w-10 h-10 text-slate-400" />
        </div>
        
        <h2 className="text-2xl font-bold text-white mb-3">
          {title}
        </h2>
        
        <p className="text-slate-300 mb-6">
          {description}
        </p>

        {features.length > 0 && (
          <div className="mb-6">
            <h3 className="text-sm font-semibold text-slate-400 mb-3 uppercase tracking-wide">
              Planned Features
            </h3>
            <ul className="space-y-2 text-left">
              {features.map((feature, index) => (
                <li key={index} className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 flex-shrink-0" />
                  <span className="text-slate-300 text-sm">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="bg-slate-800/50 border border-slate-700/50 rounded-lg p-4">
          <p className="text-sm text-slate-400">
            This workflow is in development. Follow our progress and get updates on new features.
          </p>
        </div>
      </div>
    </div>
  );
};